/**
 * v2 megamenu, JungleGift
 *
 * Contient deux choses:
 *   1. Web Component <header-submenu-tabs> qui pilote le tab switching
 *      dans le layout 3 niveaux (liste a gauche + grille a droite).
 *   2. Initializer global pour l'a11y au niveau du nav: bascule de
 *      aria-expanded sur les liens top-level selon hover/focus, et
 *      gestion de la touche Escape pour fermer le dropdown ouvert.
 *
 * Idempotent: safe meme si le script est charge plusieurs fois.
 */

(function () {
  /* ============================================================
     Web Component <header-submenu-tabs>
     ============================================================ */
  if (!customElements.get('header-submenu-tabs')) {
    class HeaderSubmenuTabs extends HTMLElement {
      connectedCallback() {
        const triggers = this.querySelectorAll('[data-tab-trigger]');
        const contents = this.querySelectorAll('[data-tab-content]');
        if (!triggers.length || !contents.length) return;

        // Active le premier trigger qui a un content matchant
        for (const trigger of triggers) {
          const tabId = trigger.dataset.tabTrigger;
          const matching = this.querySelector('[data-tab-content="' + tabId + '"]');
          if (matching) {
            trigger.classList.add('is-active');
            matching.classList.add('is-active');
            break;
          }
        }

        // Bind hover et focus sur chaque trigger pour bascule
        triggers.forEach((trigger) => {
          const activate = () => {
            const tabId = trigger.dataset.tabTrigger;
            const matching = this.querySelector('[data-tab-content="' + tabId + '"]');
            if (!matching) return;
            triggers.forEach((t) => t.classList.remove('is-active'));
            contents.forEach((c) => c.classList.remove('is-active'));
            trigger.classList.add('is-active');
            matching.classList.add('is-active');
          };
          trigger.addEventListener('mouseenter', activate);
          trigger.addEventListener('focus', activate);
        });
      }
    }
    customElements.define('header-submenu-tabs', HeaderSubmenuTabs);
  }

  /* ============================================================
     Initializer global pour l'a11y du nav
     ============================================================ */
  let escapeBound = false;

  const initNavA11y = () => {
    const items = document.querySelectorAll('.v2-nav__item');
    items.forEach((item) => {
      // Idempotent: skip si deja initialise
      if (item.dataset.v2NavInit === 'true') return;
      item.dataset.v2NavInit = 'true';

      const link = item.querySelector('.v2-nav__link');
      if (!link) return;

      let isHovered = false;
      let isFocused = false;

      const update = () => {
        const isOpen = isHovered || isFocused;
        link.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      };

      item.addEventListener('mouseenter', () => {
        isHovered = true;
        update();
      });
      item.addEventListener('mouseleave', () => {
        isHovered = false;
        update();
      });
      item.addEventListener('focusin', () => {
        isFocused = true;
        update();
      });
      item.addEventListener('focusout', () => {
        // Defer pour laisser le focus se deplacer eventuellement vers
        // un descendant avant de verifier
        setTimeout(() => {
          isFocused = item.contains(document.activeElement);
          update();
        }, 0);
      });
    });

    // Escape global: blur l'element focuse a l'interieur d'un nav-item
    // pour fermer le dropdown ouvert via :focus-within
    if (!escapeBound) {
      escapeBound = true;
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const focused = document.activeElement;
        if (focused && focused.closest && focused.closest('.v2-nav__item')) {
          focused.blur();
        }
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavA11y);
  } else {
    initNavA11y();
  }
})();
